"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _CobaltIcon = _interopRequireDefault(require("../../components/CobaltIcon"));

var CheckboxTheme = function CheckboxTheme(colors) {
  return {
    defaultProps: {
      color: 'default',
      icon: /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null),
      checkedIcon: /*#__PURE__*/_react["default"].createElement(_CobaltIcon["default"], {
        name: "checkbox-check"
      }),
      indeterminateIcon: /*#__PURE__*/_react["default"].createElement(_CobaltIcon["default"], {
        name: "checkbox-minus"
      }),
      disableRipple: true
    },
    styleOverrides: {
      root: {
        boxSizing: 'border-box',
        width: 16,
        height: 16,
        padding: 0,
        fontSize: 16,
        border: "1px solid ".concat(colors.lynch),
        borderRadius: '4px',
        '&.Mui-checked, &.MuiCheckbox-indeterminate': {
          borderColor: colors.userBlue,
          backgroundColor: colors.userBlue,
          color: '#FFFFFF'
        },
        '&.Mui-disabled': {
          borderColor: colors.grey30,
          backgroundColor: colors.grey10,
          '&.Mui-checked': {
            backgroundColor: colors.grey30,
            color: colors.white
          }
        }
      }
    }
  };
};

var _default = CheckboxTheme;
exports["default"] = _default;